module.exports = __webpack_public_path__ + "static/media/NumberOne.66d96c6a.svg";